import { useEffect, useCallback } from "react";

export const useWakeUp = (onWakeUp) => {
  const handleWakeUp = useCallback(() => {
    typeof onWakeUp === "function" && onWakeUp();
  }, [onWakeUp]);

  useEffect(() => {
    document.addEventListener(`wake_up`, handleWakeUp);
    return () => {
      document.removeEventListener(`wake_up`, handleWakeUp);
    };
  }, [handleWakeUp]);
};
